<template>
  <div>
    <ModalV2
      :title="title"
      :close-icon="null"
      :close-on-click-outside="false"
      :visible="visible"
      :hide-close-button="true"
    >
      <template #body>
        <div>
          <p class="text-medium">
            Warum kündigen Sie Ihr Abonnement?
          </p>
          <label
            v-for="(reason, index) in cancelSubscriptionFlow.cancelReasons"
            :key="index"
            class="text-medium mbs"
          >
            <input
              v-model="selectedReason"
              :disabled="processing"
              type="radio"
              name="reason"
              :value="reason.value"
            />
            {{ reason.name }}
          </label>
          <textarea
            v-model="comments"
            :disabled="processing"
            class="full-width text-medium"
            rows="3"
          ></textarea>
        </div>
      </template>
      <template #footer>
        <div>
          <div class="row align-center">
            <div class="column shrink">
              <button
                class="mbn button tiny secondary hollow"
                :disabled="!selectedReason || processing"
                @click="cancel"
              >
                Weiter Abbrechen
              </button>
            </div>
            <div class="column shrink">
              <button
                :disabled="processing"
                type="button"
                class="button tiny mbn"
                @click="close"
              >
                Premium behalten
              </button>
            </div>
          </div>
        </div>
      </template>
    </ModalV2>
    <ModalV2
      :title="title"
      :close-icon="null"
      :close-on-click-outside="false"
      :visible="isCancelledVisible"
      :hide-close-button="true"
    >
      <template #body>
        <div>
          <div class="text-center text-medium">
            <img alt="An image" :src="icons.commonLargeCancel" />
            <p
              v-html="unPrettierNuggets.subscriptionCancelled(subscription)"
            ></p>
            <p v-html="unPrettierNuggets.reactivateCopy"></p>
          </div>
        </div>
      </template>
      <template #footer>
        <div>
          <div class="row align-center">
            <div class="column shrink">
              <button
                :disabled="processing"
                class="mbs button tiny secondary hollow prm plm"
                @click="reload"
              >
                Nein danke, vielleicht später
              </button>
            </div>
            <div class="column shrink">
              <button
                :disabled="processing"
                type="button"
                class="button tiny prm plm mbs"
                @click="unCancelSubscription"
              >
                Jetzt reaktivieren
              </button>
            </div>
          </div>
        </div>
      </template>
    </ModalV2>
    <ModalV2
      :title="title"
      :close-icon="null"
      :close-on-click-outside="false"
      :visible="isUncancelledVisible"
      :hide-close-button="true"
    >
      <template #body>
        <div>
          <div class="text-center text-medium">
            <img alt="An image" :src="icons.commonLargeAnnualPremium" />
            <p
              v-html="unPrettierNuggets.subscriptionUnCancelled(subscription)"
            ></p>
          </div>
        </div>
      </template>
      <template #footer>
        <div>
          <div class="row align-center">
            <div class="column shrink">
              <button
                class="mbs button tiny secondary hollow prm plm"
                type="button"
                @click="reload"
              >
                Schliessen
              </button>
            </div>
          </div>
        </div>
      </template>
    </ModalV2>
  </div>
</template>

<script>
import axios from 'axios';
import ModalV2 from '../../../../shared/Modal/ModalV2.vue';

const axiosConfig = {
  headers: {
    'Content-Type': 'application/json',
  },
};

export default {
  components: {
    ModalV2,
  },
  props: {
    cancelSubscriptionFlow: {
      type: Object,
      required: true,
    },
    subscription: {
      type: Object,
      required: true,
    },
    icons: {
      type: Object,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isVisible: this.visible,
      isCancelledVisible: false,
      isUncancelledVisible: false,
      isReasonChecked: false,
      comments: '',
      selectedReason: null,
      state: 'cancel',
      processing: false,
      unPrettierNuggets: {
        subscriptionCancelled: (subscription) => {
          return `Ihr <strong>${subscription.subscriptionFor}</strong>-Abonnement wurde gekündigt. Sie können bis zum Ende Ihres aktuellen Abonnementzeitraums, der am <strong>${this.subscription.renewalDateCopy}</strong> abläuft, auf die Vorteile Ihres Abonnements zugreifen.`;
        },
        subscriptionUnCancelled: (subscription) => {
          return `Ihr <strong>${subscription.subscriptionFor}</strong>-Abonnement wurde reaktiviert. ${this.subscription.autoRenewalCopy}`;
        },
        reactivateCopy: `Wenn Sie Ihr Abonnement nicht kündigen wollten oder es erneut abonnieren möchten, können Sie dies schnell und einfach tun, indem Sie unten klicken.`,
      },
      reloadUrl: null,
    };
  },
  computed: {
    title() {
      if (this.state === 'cancel') {
        return `Wir bedauern, dich gehen zu sehen!`;
      }

      if (this.state === 'cancelled') {
        return `Stornierung bestätigt`;
      }

      if (this.state === 'uncancelled') {
        return `Reaktiviert!`;
      }

      return '';
    },
  },
  methods: {
    async cancel(e) {
      e.preventDefault();

      if (!this.selectedReason) return;

      this.processing = true;

      const data = {
        subscriptionId: this.subscription.subscriptionId,
        reason: this.selectedReason,
        comments: this.comments,
      };
      const res = await axios
        .post(
          this.cancelSubscriptionFlow.cancelSubscriptionApi,
          data,
          axiosConfig,
        )
        .catch(function (error) {
          if (error.response.data && error.response.data.redirectUrl) {
            window.location.href = error.response.data.redirectUrl;
          }
        });
      if (res.status === 200) {
        this.state = 'cancelled';
        this.close();
        this.isCancelledVisible = true;
        this.processing = false;
        this.reloadUrl = res.data.redirectUrl;
      }
    },
    async unCancelSubscription() {
      this.processing = true;

      const res = await axios
        .post(
          this.cancelSubscriptionFlow.unCancelSubscriptionApi,
          {
            subscriptionId: this.subscription.subscriptionId,
          },
          axiosConfig,
        )
        .catch(function (error) {
          if (error.response.data && error.response.data.redirectUrl) {
            window.location.href = error.response.data.redirectUrl;
          }
        });

      if (res.status === 200) {
        this.state = 'uncancelled';
        this.close();
        this.isCancelledVisible = false;
        this.isUncancelledVisible = true;
        this.processing = false;
        this.reloadUrl = res.data.redirectUrl;
      }
    },
    async reload() {
      this.processing = true;
      window.location.href = this.reloadUrl;
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>
